import { GetMeQuery } from "generated/graphql";
import React from "react";

export const LoggedInUserContext = React.createContext<
  GetMeQuery['me'] | undefined
>(undefined);
